// extracted by mini-css-extract-plugin
export default {"darkTheme":"style_darkTheme__8BHXs","lightTheme":"style_lightTheme__snf+F"};